@use '@fukuri-admins/ui/layout' as *;

.Header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  background-color: background('Primary');
  &__Title {
    font-weight: 700;
    font-size: 16px;
    color: text('High')
  }
}
